import React from 'react';

import Feed from '@components/Feed';
import { ArticleOrBriefing } from '@components/Feed/ArticleOrBriefingFeedItem';

interface SearchArticlesListProps {
  content: ArticleOrBriefing[];
  offerCode?: string;
}

const SearchArticlesList = ({ content, offerCode }: SearchArticlesListProps) => {
  return <Feed articlesOrBriefings={content} offerCode={offerCode} />;
};

export default SearchArticlesList;
